module.exports = __webpack_public_path__ + "img/5-2package.b8c358d9.png";